import React from 'react'
import {useTranslation} from 'react-i18next'
import {Carousel, Col, Layout, Row} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'
import {TerminalType} from '@/constants'
import {
    TransactionsCardWithBarChartContainer,
    TransactionSummaryListContainer,
    UserGuideStoreSymbol
} from '@/components/containers'
import {TSettlementsTransactionsCardWithBarChartContainerStore} from '@/stores/reports/SettlementsTransactionsCardWithBarChartContianerStore/TSettlementsTransactionsCardWithBarChartContainerStore'
import {generateChartTitleForRange} from '@/stores'
import { SHOW_CAROUSEL } from '@/constants/overview-carousel'
import {CarouselWidgetItemBeta} from '../CarouselWidgetItemBeta'
import {urls} from '~/code/constants/urls'
import { TUserGuideStore } from '~/code/components/containers/UserGuideContainer/TUserGuideStore'
import styles from './styles.scss'


export const OverviewSettlementsTransactionSummaryStoreSymbol = Symbol(
    'OverviewSettlementsTransactionSummaryStore'
)
export const OverviewSettlementsTransactionsCardWithBarChartContainerStoreSymbol = Symbol(
    'OverviewSettlementsTransactionCardWithBarChartContainerStore'
)

const OverviewSettlementsAnalytics: React.FC<{}> = observer(() => {
    const {t} = useTranslation()
    const {setIsModalVisible} = useInjection<TUserGuideStore>(UserGuideStoreSymbol)
    const transactionStore = useInjection<TSettlementsTransactionsCardWithBarChartContainerStore>(
        OverviewSettlementsTransactionsCardWithBarChartContainerStoreSymbol
    )


    const appStoreUrl = 'https://apps.apple.com/eg/app/dna-payments/id6478762280'
    const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.dnapayments.mp&hl=en'

    return (
        <>
            <Layout.Content className={styles.body}>
                <Row gutter={[16, 16]}>
                    <Col span={24} xs={24}>
                        <TransactionSummaryListContainer
                            type={TerminalType.SETTLEMENTS}
                            injectableIdentifier={OverviewSettlementsTransactionSummaryStoreSymbol}
                        />
                    </Col>
                    <Col span={24}>
                        <TransactionsCardWithBarChartContainer
                            title={`${t('OverviewSettlementsAnalytics.settlementsHistory')} ${generateChartTitleForRange(transactionStore.interval) || ''}`}
                            injectableIdentifier={
                                OverviewSettlementsTransactionsCardWithBarChartContainerStoreSymbol
                            }
                        />
                    </Col>
                    
                    {
                        SHOW_CAROUSEL && (
                            <>
                                <Col span={12} xs={24} sm={24} md={24} lg={12}>
                                    <Carousel autoplay>
                                        <CarouselWidgetItemBeta
                                            variant='cashAdvanced'
                                            tagline={t('Overview.expandYourBusiness')}
                                            title={t('Overview.cashAdvance')}
                                            bulletPoints={[
                                                t('Overview.upToAmount'),
                                                t('Overview.fixedFee'),
                                                t('Overview.fundsInTime')
                                            ]}
                                            linkText={t('Overview.learnMore')}
                                            linkUrl={urls.cashAdvance}
                                        />
                                    </Carousel>
                                </Col>
                                <Col span={12} xs={24} sm={24} md={24} lg={12}>
                                    <Carousel autoplay>
                                        <CarouselWidgetItemBeta
                                            variant='downloadApp'
                                            tagline={t('Overview.merchantPortal')}
                                            title={t('Overview.downloadTheApp')}
                                            description={t('Overview.downloadTheAppDescription')}
                                            compactDescription={t('Overview.downloadTheAppCompact')}
                                            customContent={(isCompactMode) => (
                                                <span className={isCompactMode ? styles.storeBadgesMobile : styles.storeBadges}>
                                                    <a
                                                        href={appStoreUrl}
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                    >
                                                        <img
                                                            src='/img/overview/appstore.svg'
                                                            alt={t('Overview.downloadOnAppStore')}
                                                            className={styles.storeBadge}
                                                        />
                                                    </a>
                                                    <a
                                                        href={googlePlayUrl}
                                                        target='_blank'
                                                        rel='noopener noreferrer'
                                                    >
                                                        <img
                                                            src='/img/overview/googleplay.svg'
                                                            alt={t('Overview.getItOnGooglePlay')}
                                                            className={styles.storeBadge}
                                                        />
                                                    </a>
                                                </span>
                                            )}
                                        />
                                        <CarouselWidgetItemBeta
                                            variant='productGuide'
                                            tagline={t('Overview.merchantPortal')}
                                            title={t('Overview.productGuides')}
                                            description={t('Overview.toHelpYouGetStarted')}
                                            compactDescription={t('Overview.productGuidesCompact')}
                                            linkText={t('Overview.merchantPortalGuide')}
                                            linkUrl={urls.guides}
                                        />
                                        <CarouselWidgetItemBeta
                                            variant='whereToStart'
                                            tagline={t('Overview.merchantPortal')}
                                            title={t('Overview.whereToStart')}
                                            description={t('Overview.onlinePaymentSystem')}
                                            compactDescription={t('Overview.whereToStartCompact')}
                                            linkText={t('Overview.learnMore')}
                                            linkUrl='#'
                                            onLinkClick={() => setIsModalVisible(true)}
                                        />
                                    </Carousel>
                                </Col>
                            </>
                        )
                    }
                </Row>
            </Layout.Content>
        </>
    )
})

export default OverviewSettlementsAnalytics
